import { DetailTable } from '../../../mapping-classes/detail-table';

export class MandateListings implements DetailTable {
  shieldedText = 'Afgeschermd';
  restrictedData: boolean;
  title: string;
  rowHeaders: string[];
  rowData: any[];
  errorText: string;

  constructor(mandateListings: any) {
    if (!mandateListings) {
      this.createErrorMessage();
    } else {
      this.rowHeaders = [];
      this.rowData = [];
      this.setRowHeaders();
      this.setRowData(mandateListings);
    }
  }

  createErrorMessage() {
    this.errorText = '';
  }

  setRowHeaders() {
    this.rowHeaders = [
      'incassantName',
      'incassantId',
      'machtigingskenmerk'
    ];
  }

  setRowData(basicTableData) {
    basicTableData.forEach((details) => {
      this.rowData.push(details);
    });
  }
}
